//config.js

const apiUrl = process.env.NODE_ENV === 'production'
    ? "https://api.intranet.nova-portage.com/api" // API en production
    : "http://localhost:5000/api"; // API en développement local

export default apiUrl;

//const apiUrl = "https://api.biam-consulting.fr/api"; // Remarquez qu'il n'y a pas de `${}`
//export default apiUrl;
